import { render, staticRenderFns } from "./GestionInformes.vue?vue&type=template&id=0b53375b&"
import script from "./GestionInformes.vue?vue&type=script&lang=js&"
export * from "./GestionInformes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports